import { Component } from '@angular/core';

// 1. Interface for Fun Facts
export interface FactItem {
  value: string;
  label: string;
  delay: string;
}

// 2. Interface for Blog Items
export interface BlogItem {
  blogImage: string;
  category: string;
  link: string;
  authorImage: string;
  authorName: string;
  date: string;
  summary: string;
  shares: string;
  comments: string;
  delay: string;
}

@Component({
  standalone: false,
  selector: 'app-blog-grid',
  templateUrl: './blog-grid.component.html',
  styleUrl: './blog-grid.component.css'
})
export class BlogGridComponent {

  // Fun Facts Data Array
  facts: FactItem[] = [
    {
      value: '99',
      label: 'Success in getting happy customer',
      delay: '.1s'
    },
    {
      value: '25',
      label: 'Thousands of successful business',
      delay: '.3s'
    },
    {
      value: '120',
      label: 'Total clients who love HighTech',
      delay: '.5s'
    },
    {
      value: '5',
      label: 'Stars reviews given by satisfied clients',
      delay: '.7s'
    }
  ];

  // Lifecycle Hooks
  ngOnInit(): void {
    // Initialization code (if any)
  }

  ngOnDestroy(): void {
    // Cleanup code (if any)
  }


  // Blog Posts Data Array
  blogs: BlogItem[] = [
    {
      blogImage: 'assets/images/blog-1.jpg',
      category: 'Web Design',
      link: '/blog-grid',
      authorImage: 'assets/images/admin.jpg',
      authorName: 'Morris Jeff',
      date: '24 March 2025',
      summary: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt libero sit amet',
      shares: '5324',
      comments: '5',
      delay: '.3s'
    },
    {
      blogImage: 'assets/images/blog-2.jpg',
      category: 'Development',
      link: '/blog-grid',
      authorImage: 'assets/images/admin-2.jpg',
      authorName: 'Sofia Doe',
      date: '23 April 2024',
      summary: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt libero sit amet',
      shares: '5324',
      comments: '5',
      delay: '.5s'
    },
    {
      blogImage: 'assets/images/blog-3.jpg',
      category: 'Mobile App',
      link: '/blog-grid',
      authorImage: 'assets/images/admin-3.jpg',
      authorName: 'Alex Doe',
      date: '30 Jan 2025',
      summary: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt libero sit amet',
      shares: '5324',
      comments: '5',
      delay: '.7s'
    }
  ];
}
